import { render, staticRenderFns } from "./CertificationTypeList.vue?vue&type=template&id=6ffe47c8&scoped=true&"
import script from "./CertificationTypeList.vue?vue&type=script&lang=js&"
export * from "./CertificationTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffe47c8",
  null
  
)

export default component.exports